import {Provider} from '@angular/core';

import {BraintreeEnTranslationConfig} from '../config/braintree.en.translation.config';

export const BRAINTREE_EN_TRANSLATION_PROVIDER: Provider[] = [
    {
        provide: BraintreeEnTranslationConfig,
        useClass: BraintreeEnTranslationConfig
    }
];
